import {IState, ACTION_VERBS as ACTIONS} from './Types';

import {parser} from './Parser';

/**
 *
 */
export const initialState: IState = {
  errors: [],
  banks: [],
  entities: [],
  profile: null,
  balances: null,
  balanceSheet: null,
  notifications: null,
  uiConfiguration: null,
  history: null,
  documents: null,
  semaphoreItems: null,
  debtors: null,
  receivables: null,
  isOutdated: null,
  goToMessages: false,
  salesmanClients: null,
  subClientBalances: null,
  salesTerritories: [],
  customerTypes: [],
  customerRequiredDocumentList: [],
  customerRequiredDocumentsHelp: null,
  customerPaymentOptions: [],
  salesmanOrderItemCandidate: null,
  salesmanClient: null,
  balanceSheetSubClient: null,
  isLocalizationActive: false,
  invoiceFeeSummaryList: null,
  invoiceFeeSummary: null,
  invoiceFeeListToPay: null,
  basePaymentC2P: null,
  statePaymentC2P: null,
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export const reducer = (state: IState, action: any) => {
  switch (action.type) {
    case ACTIONS.BALANCE_LIST:
      return {
        ...parser.balanceList(state, action.payload),
      } as IState;
    case ACTIONS.HISTORY:
      return {
        ...parser.history(state, action.payload),
      } as IState;
    case ACTIONS.BALANCE_SHEET_SALESMAN:
      return {
        ...parser.balanceSheetSalesman(state, action.payload),
      } as IState;
    case ACTIONS.BALANCE_SHEET:
      return {
        ...parser.balanceSheet(state, action.payload),
      } as IState;
    case ACTIONS.NOTIFICATION_LIST:
      return {
        ...parser.notificatioList(state, action.payload),
      } as IState;
    case ACTIONS.DOCUMENT_LIST:
      return {
        ...parser.documentList(state, action.payload),
      } as IState;
    case ACTIONS.SEMAPHORE_ITEMS:
      return {
        ...parser.semaphoreItems(state, action.payload),
      } as IState;
    case ACTIONS.DEBTOR_LIST:
      return {
        ...parser.debtorList(state, action.payload),
      } as IState;
    case ACTIONS.RECEIVABLE_LIST:
      return {
        ...parser.receivableList(state, action.payload),
      } as IState;

    case ACTIONS.GET_SALESMAN_CLIENTS:
      return {
        ...parser.salesmanClientList(state, action.payload),
      } as IState;
    case ACTIONS.GET_SALESMAN_PRODUCTS:
      return {
        ...parser.salesmanProductList(state, action.payload),
      } as IState;
    case ACTIONS.SET_SALESMAN_PRODUCT_TO_ADD:
      return {
        ...parser.setSalesmanProductToAdd(state, action.payload),
      } as IState;
    case ACTIONS.UPDATE_SALESMAN_NEW_ORDER:
      return {
        ...parser.updateSalesmanNewOrder(state, action.payload),
      } as IState;

    case ACTIONS.UPDATE_ORDER_ITEM_CANDIDATE_SHOPPING_CART:
      return {
        ...parser.updateCandidateToShoppingCart(state, action.payload),
      } as IState;
    case ACTIONS.SEND_SALESMAN_NEW_ORDER:
      return {
        ...parser.sendSalesmanNewOrder(state),
      } as IState;
    case ACTIONS.SET_SALESMAN_CLIENT:
      return {
        ...parser.setSalesmanClient(state, action.payload),
      } as IState;
    case ACTIONS.FETCH_INVOICE_FEE_SUMARY_LIST:
      return {
        ...parser.setState('invoiceFeeSummaryList', state, action.payload),
      } as IState;
    case ACTIONS.SET_INVOICE_FEE_SUMMARY:
      return {
        ...parser.setState('invoiceFeeSummary', state, action.payload),
      } as IState;

    case ACTIONS.SET_INVOICE_FEE_LIST_TO_PAY:
      return {
        ...parser.setState('invoiceFeeListToPay', state, action.payload),
      } as IState;
    case ACTIONS.FETCH_BASE_PAYMENT_C2P:
      return {
        ...parser.setState('basePaymentC2P', state, action.payload),
      } as IState;
    case ACTIONS.SEND_PAYMENT_C2P:
      return {
        ...parser.setState('statePaymentC2P', state, action.payload),
      } as IState;
    case ACTIONS.SEND_PROOF_FEE_PAYMENT_CONFIRMATION:
      return {
        ...parser.setState('statePaymentC2P', state, null),
      } as IState;
    case ACTIONS.SEND_CREDIT_CARD_PAYMENT:
    default:
      return state;
  }
};
